import { defineAsyncComponent } from 'vue'
export default {
  "app-sidebar": defineAsyncComponent(() => import("/home/mariotrombino/git/progetti/NewMed/app/layouts/AppSidebar.vue").then(m => m.default || m)),
  "composables-layout": defineAsyncComponent(() => import("/home/mariotrombino/git/progetti/NewMed/app/layouts/composables/layout.js").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/mariotrombino/git/progetti/NewMed/app/layouts/default.vue").then(m => m.default || m))
}